import React, { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import VideoCard from "./VideoCard";

export default function ContentRow({ title, items, variant = "wide", testId, live = false }) {
  const ref = useRef(null);
  if (!items || items.length === 0) return null;

  const scroll = (dir) => {
    const el = ref.current;
    if (!el) return;
    el.scrollBy({ left: dir * (el.clientWidth * 0.8), behavior: "smooth" });
  };

  return (
    <section data-testid={testId || "content-row"} className="px-3 sm:px-6 md:px-10 py-4 sm:py-6 tv-reveal">
      <div className="flex items-end justify-between mb-3 sm:mb-4 gap-2">
        <h2 className="font-display font-bold text-xl sm:text-2xl md:text-3xl text-white tracking-tight">{title}</h2>
        <div className="hidden sm:flex gap-2">
          <button
            data-testid={`${testId}-scroll-left`}
            onClick={() => scroll(-1)}
            className="tv-glass w-9 h-9 rounded-full flex items-center justify-center text-white/80 hover:text-white"
            aria-label="Scroll left"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
          <button
            data-testid={`${testId}-scroll-right`}
            onClick={() => scroll(1)}
            className="tv-glass w-9 h-9 rounded-full flex items-center justify-center text-white/80 hover:text-white"
            aria-label="Scroll right"
          >
            <ChevronRight className="w-5 h-5" />
          </button>
        </div>
      </div>
      <div
        ref={ref}
        className="flex overflow-x-auto snap-x snap-mandatory gap-3 sm:gap-4 hide-scrollbar pb-2 pt-1 -mx-1 px-1"
      >
        {items.map((it) => (
          <VideoCard key={it.id} item={it} variant={variant} live={live || it.is_live} />
        ))}
      </div>
    </section>
  );
}
